/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Insert blocks by name",
  "description": "Middle click on the code area, use Ctrl+Space or Shift+Click to bring up a floating input box where you can type the name of a block (or parts of it) and drag the block into the code area. Hold Shift while dragging to avoid closing the box when adding multiple blocks at once.",
  "credits": [
    {
      "name": "griffpatch"
    },
    {
      "name": "TheColaber",
      "link": "https://scratch.mit.edu/users/TheColaber/"
    },
    {
      "name": "JeremyGamer13"
    },
  ],
  "tags": [
    "recommended"
  ],
  "enabledByDefault": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "userstyle.css"
    }
  ],
  "settings": [
    {
      "name": "Popup Block Size",
      "id": "popup_scale",
      "type": "integer",
      "min": 1,
      "max": 100,
      "default": 64
    },
    {
      "name": "Popup Default Width",
      "id": "popup_width",
      "type": "integer",
      "min": 1,
      "max": 100,
      "default": 16
    },
    {
      "name": "Popup Max Search Height",
      "id": "popup_max_height",
      "type": "integer",
      "min": 1,
      "max": 100,
      "default": 40
    },
    {
      "name": "Max Search Results",
      "id": "popup_max_search",
      "type": "integer",
      "min": 1,
      "max": 1000,
      "default": 100
    },
    {
      "name": "Max Object Variants",
      "id": "popup_max_variants",
      "type": "integer",
      "min": 1,
      "max": 1000,
      "default": 7
    }
  ],
  "info": [
    {
      "text": "This addon was previously part of the \"developer tools\" addon but has moved here.",
      "id": "developer-tools"
    },
    {
      "text": "Changing the \"Max Object Variants\" will limit the amount of results that just use a different costume, sprite, sound or menu option selected in the block.",
      "id": "maxObjectVariants"
    }
  ]
};
export default manifest;
